import { Component, Input, OnInit, EventEmitter, Output } from '@angular/core';
import { QuestionBase } from '../question-base';
import { FormBuilder, FormGroup, Validators, FormArray, FormControl, ControlContainer, NgForm } from '@angular/forms';
import { constants } from '../../utitlity/constant';

@Component({
    selector: "ntb-text",
    template: require('./text.component.html'),
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }]
})
export class TextFieldComponent implements OnInit {
    @Input() question: any;
    @Input() questions: any = [];
    @Input() form: NgForm;
    // @Input() prefillData: any;
    fieldModel: any;
    pattern : string;
    // @Output() onNumberChange: EventEmitter<any> = new EventEmitter<any>();
    isLeadFormApplication: boolean;
    
    constructor() { }
    ngOnInit() {
        // if(this.question.backendField == 'promoCode'){
        //     this.question.required = false;
        // }
        this.getPattern();
        this.isLeadFormApplication = constants.IS_LEAD_FORM_APPLICATION;
    }
    getPattern(){
        switch(this.question.type){
            case 'alphaNumeric':
                this.pattern = '^[a-zA-Z0-9]+$'
            break;

            case 'numericSlash':
                this.pattern = '^[0-9/]+$';
            break;
            
            case 'alphaWithSpace':
            this.pattern = '^[a-zA-Z ]*$'
            break;

            case 'alphaWithSpecialCharacter':
            this.pattern = '^[a-zA-Z/.&,\\s\_\-]*$'
            break;
            
            case 'alphaNumericWithSpace':
                this.pattern = "^[ a-zA-Z(\\\\)0-9#;,_. :\"'/-]+$";
            break;
            
            default:
                this.pattern = '';

        }
    } 

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/lodash/lodash.js!./~/tslint-loader!./src/app/components/text/text.component.ts